import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CountryData, countyData, CustomerDetailsPayload, StateData, WellDetailsPayload } from "../model/calculations/calculation";
import { getAccountManager, getCountry, getCounty, getCustomerById, getState, getWellDetails, getWellDetailsById } from "../../services/createProject.services";
import { act } from "react";
import { designType, jetliftID } from "../model/jetlift/jetlift";

interface ICreateProjectState {
    projectName: string,
    caseName: string,
    represtative: string,
    formation: string,
    contact: string,
    well: number | string,
    country: number | string,
    countyOther: number | string,
    state: number | string,
    county: number | string,
    customer: number | string,
    loading: boolean;
    error: string | undefined;
    wellByIdValues: { [key: string]: any } | any;
    customerByIdValues: { [key: string]: any } | any
    stateList: any;
    countryList: any;
    countyList: any;
    wellList: any;
    customerList: any;
    wellApiNo: string | number;
    countyNameList: any;
    equiment: number;
    filteredCountryList: any;
    handleSubmit: any;
    duplicateCountryList: any;
    duplicateStateList: any;
    duplicateCountyList: any;
    unitMeasurement: number;
    caseDescription: string;
    template: string;
    wellID: number | string | null;
    customerID: number | string | null;
    accountManagerList: any;
    accountManagerDuplicateList: any;
    accountManager: string;
    customerSearchKey: string;
    wellSearchKey: string;
    liftOption: designType;
    jetliftProjectID: jetliftID;
}

export const initialState: ICreateProjectState = {
    projectName: "",
    caseName: "",
    represtative: "",
    formation: "",
    contact: "",
    well: "",
    country: "",
    countyOther: "",
    state: "",
    county: "",
    customer: "",
    loading: false,
    error: '',
    wellByIdValues: [],
    customerByIdValues: [],
    stateList: [],
    countryList: [],
    countyList: [],
    wellList: [],
    customerList: [],
    wellApiNo: "",
    countyNameList: [],
    equiment: 0,
    filteredCountryList: [],
    handleSubmit: "",
    duplicateCountryList: [],
    duplicateStateList: [],
    duplicateCountyList: [],
    unitMeasurement: 0,
    caseDescription: "",
    template: "",
    wellID: null,
    customerID: null,
    accountManagerList: [],
    accountManagerDuplicateList: [],
    accountManager: "",
    customerSearchKey: "",
    wellSearchKey: "",
    liftOption: {
        designType: "ESP",
        id: 1
    },
    jetliftProjectID: {
        projectID: "",
        caseID: "",
        templateID: "",
        projectName: "",
    },
}


export const gettingWell = createAsyncThunk(
    "connexia-cNXWell/gettingWell",
    async (payload: WellDetailsPayload) => {
        const response = await getWellDetails(payload);
        return response;
    }
);


export const gettingCustomer = createAsyncThunk(
    "connexia-cNXWell/gettingCustomer",
    async (_payload: CustomerDetailsPayload) => {
        return [];
    }
);

export const gettingWellDetailsById = createAsyncThunk(
    "connexia-cNXWellsById/gettingWellDetailsById",
    async (payload: number) => {

        const response = await getWellDetailsById(payload);
        return response;
    }
);

export const gettingCustomerDetailsById = createAsyncThunk(
    "connexia-cNXCustomerById/gettingCustomerDetailsById",
    async (payload: number) => {
        const response = await getCustomerById(payload);
        return response;
    }
);

export const gettingCountry = createAsyncThunk(
    "calculation-Project/gettingCountry",
    async () => {
        try {
            const response = await getCountry();
            return response;
        } catch (error) {
            throw Error("Error fetching county  list: " + error);
        }
    }
);

export const gettingState = createAsyncThunk(
    "calculation-Project/gettingState",
    async ({
        State,

    }: {
        State: string;
    }) => {
        if (State === "0"){
            return [];
        }
        try {
            const response = await getState(State);
            return response;
        } catch (error) {
            throw Error("Error fetching county  list: " + error);
        }
    }
);


export const gettingCounty = createAsyncThunk(
    "calculation-Project/gettingCounty",
    async ({
        stateID,
    }: {
        stateID: string;
    }) => {
        try {
            const response = await getCounty(stateID);
            return response;
        } catch (error) {
            throw Error("Error fetching county  list: " + error);
        }
    }
);

export const getAccountManagerList = createAsyncThunk(
    "calculation-Project/getAccountManagerList",
    async () => {
        try {
            const response = await getAccountManager();
            return response;
        } catch (error) {
            throw Error("Error fetching county  list: " + error);
        }
    }
);

const customResetValues = {
    caseName: "",
    contact: "",
    country: "",
    county: "",
    countyOther: "",
    customer: "",
    equiment: 0,
    formation: "",
    projectName: "",
    represtative: "",
    state: "",
    well: "",
    wellApiNo: "",
};

const CreateProjectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setProjectName(state, action) {
            state.projectName = action.payload;
        },
        setCaseName(state, action) {
            state.caseName = action.payload;
        },
        setReprestative(state, action) {
            state.represtative = action.payload;
        },
        setFormation(state, action) {
            state.formation = action.payload;
        },
        setContact(state, action) {
            state.contact = action.payload;
        },
        setWellList(state, action) {
            state.wellList = action.payload;
        },
        setCustomerList(state, action) {
            state.customerList = action.payload;
        },
        setCountryList(state, action) {
            state.countryList = action.payload;
        },
        setTemplate(state, action) {
            state.template = action.payload;
        },
        setStateList(state, action) {
            state.stateList = action.payload;
        },
        setState(state, action) {
            state.state = action.payload;
        },
        setCountyList(state, action) {
            state.countyList = action.payload;
        },
        setfilteredCountryList(state, action) {
            state.filteredCountryList = action.payload;
        },
        setCounty(state, action) {
            state.county = action.payload;
        },
        setCustomer(state, action) {
            state.customer = action.payload;
        },
        setCustomerID(state, action) {
            state.customerID = action.payload;
        },
        setWellDetailsById(state, action) {
            state.wellByIdValues = action.payload;
        },
        setCustomerDetailsById(state, action) {
            state.customerByIdValues = action.payload
        },
        setWell(state, action) {
            state.well = action.payload
        },
        setWellID(state, action) {
            state.wellID = action.payload
        },
        setWellApiNo(state, action) {
            state.wellApiNo = action.payload
        },
        setCountry(state, action) {
            state.country = action.payload
        },
        setCountyNameList(state, action) {
            state.countyNameList = action.payload
        },
        setCountyOther(state, action) {
            state.countyOther = action.payload;
        },
        setEqupiment(state, action) {
            state.equiment = action.payload;
        },
        setunitMeasurement(state, action) {
            state.unitMeasurement = action.payload;
        },
        setCaseDescription(state, action) {
            state.caseDescription = action.payload;
        },
        setDuplicateCountyList(state, action) {
            state.duplicateCountyList = action.payload;
        },
        setAccountManagerList(state, action) {
            state.accountManagerList = action.payload
        },
        setAccountManager(state, action) {
            state.accountManager = action.payload;
        },
        setCustomerSearch(state, action) {
            state.customerSearchKey = action.payload;
        },
        setWellSearch(state, action) {
            state.wellSearchKey = action.payload;
        },
        setLiftOption(state, action) {
            state.liftOption.designType = action?.payload?.designType;
            state.liftOption.id = action?.payload?.id;
        },
        setJetliftProjectID(state, action) {
            state.jetliftProjectID.projectID = action?.payload?.projectID || "";
            state.jetliftProjectID.caseID = action?.payload?.caseID || "";
            state.jetliftProjectID.templateID = action?.payload?.templateID || "";
            state.jetliftProjectID.projectName = action?.payload?.projectName || "";
        },
        resetProjectState: (state) => {
            state.accountManager = "";
            state.caseName = "";
            state.contact = "";
            state.country = "";
            state.county = "";
            state.countyOther = "";
            state.equiment = 0;
            state.formation = "";
            state.projectName = "";
            state.represtative = "";
            state.state = "";
            state.well = "";
            state.wellApiNo = "";
            state.caseDescription = "";
            state.customer = "";
            state.duplicateStateList = [];
            state.stateList = [];
            state.countyList = [];
            state.duplicateCountyList = [];
            state.liftOption.designType = "ESP";
            state.liftOption.id = 1;
        },

    },
    extraReducers: (builder) => {
        builder.addCase(gettingWell.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingWell.fulfilled, (state, action) => {
            if (action.payload) {
                const wellValues = action.payload?.map((item: any) => ({
                    label: item.name,
                    value: item.cnxWellId,
                    country: item.country,
                    apino: item.apiNumber,
                    state: item.state,
                    county: item.county,
                    operator: item.company,
                    operatorId: item.companyID,
                    operatorContact: item.CompanyContact,
                    formation: item.formation,
                }));
                state.wellList = wellValues || [];
                state.loading = false;
                state.error = "";
            }
        });
        builder.addCase(gettingWell.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingCustomer.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCustomer.fulfilled, (state, action) => {
            if (action.payload) {
                let vals = Array.isArray(action?.payload) ? action?.payload : [action?.payload];
                const customerValues = vals?.map((item: any) => ({
                    label: item.customerName,
                    value: item.connexiaID || item.cnxid,
                    id: item.id
                }));
                state.customerList = customerValues || [];
                state.loading = false;
                state.error = "";
            }
        });
        builder.addCase(gettingCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingWellDetailsById.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingWellDetailsById.fulfilled, (state, action) => {
            state.wellByIdValues = action.payload;
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingWellDetailsById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingCustomerDetailsById.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetailsById.fulfilled, (state, action) => {
            state.customerByIdValues = action.payload;
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetailsById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingState.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingState.fulfilled, (state, action) => {
            if (action.payload) {
                const stateArray = action.payload.map((item: any) => ({
                    label: item?.stateName,
                    value: item?.stateID
                }))
                stateArray.unshift({
                    value: "-2",
                    label: "-Select-",
                });
                state.stateList = stateArray || [];
                state.duplicateStateList = stateArray || [];
            }
        });
        builder.addCase(gettingState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingCountry.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCountry.fulfilled, (state, action) => {
            if (action.payload) {
                const countryArray = action.payload.map((item: any) => ({
                    label: item?.countryName,
                    value: item?.id,
                    countryCode: item.countryCode,
                }))
                countryArray.unshift({
                    value: "-2",
                    label: "-Select-",
                });
                state.countryList = countryArray || [];
                state.duplicateCountryList = countryArray || [];
            }
        });
        builder.addCase(gettingCountry.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingCounty.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCounty.fulfilled, (state, action) => {
            if (action.payload) {
                const transformedData = Object.entries(action.payload).map(([key, value]) => ({
                    label: key,
                    value: value
                }));
                transformedData.unshift({
                    value: "-2",
                    label: "-Select-",
                });
                state.countyList = transformedData || [];
                state.duplicateCountyList = transformedData || [];
            }
        });
        builder.addCase(gettingCounty.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(getAccountManagerList.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(getAccountManagerList.fulfilled, (state, action) => {
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                const managerData = action.payload.map((item: any) => ({
                    label: item?.firstName + " " + item?.lastName,
                    value: item?.email
                }));
                managerData.unshift({
                    value: "-2",
                    label: "-Select-",
                });
                state.accountManagerList = managerData || [];
                state.accountManagerDuplicateList = managerData || [];
            }
        });
        builder.addCase(getAccountManagerList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});

export const {
    setProjectName,
    setCaseName,
    setReprestative,
    setFormation,
    setContact,
    setWellList,
    setCountry,
    setStateList,
    setState,
    setCustomer,
    setCustomerList,
    setWellDetailsById,
    setCustomerDetailsById,
    setWell,
    setWellApiNo,
    setCountryList,
    setCountyNameList,
    setCountyList,
    setCounty,
    setCountyOther,
    setEqupiment,
    setfilteredCountryList,
    resetProjectState,
    setunitMeasurement,
    setCaseDescription,
    setDuplicateCountyList,
    setTemplate,
    setWellID,
    setCustomerID,
    setAccountManagerList,
    setAccountManager,
    setCustomerSearch,
    setWellSearch,
    setLiftOption,
    setJetliftProjectID,
} = CreateProjectSlice.actions;

export default CreateProjectSlice.reducer;